import React from 'react'
import PropTypes from 'prop-types'
import 'react-intl-tel-input/dist/libphonenumber'
import 'react-intl-tel-input/dist/main.css'
import './IntlTelInput.css'
import validator from 'validator'

const divStyle = {width: '100%'}
const divFlag = {left: '0'}

class RFIntlTelInput extends React.Component {
  render () {
    const {input: {value}, meta: {touched, error}} = this.props

    return <div style={divStyle} className={`${this._wrapperClassName()} intl-tel-input`}>
      <div className='flag-container' style={divFlag}>
        <div className='selected-flag'>
          <div className='iti-flag id' />
        </div>
      </div>
      <input type='tel' autoComplete='off' className='form-control telCustomInput' name='support_phone' placeholder='0812-345-678' onChange={this.phoneNumChangeHandler} value={value} />
      {touched && error && <span className={`form-control-feedback glyphicon glyphicon-remove`} />}
      {touched && !error && <span className={`form-control-feedback glyphicon glyphicon-ok`} />}
      {touched && error && <span className='form-feedback'>{error}</span>}
    </div>
  }

  phoneNumChangeHandler = ({target}) => {
    const {input: {onChange, value}} = this.props
    const phone = target.value

    // if addition of char
    if (phone.length > value.length) {
      if (!validator.isNumeric(phone)) {
        return false
      }
    }

    if (phone.length >= 1 && !phone.startsWith('0')) {
      onChange(`0${phone}`)
    } else {
      onChange(phone)
    }
  }

  _wrapperClassName = () => {
    const {meta: {touched, error}} = this.props
    return `${touched ? (error ? 'has-feedback has-error' : 'has-feedback has-success') : ''}`
  }
}

class IntlTelInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.value
    }
  }

  render () {
    // return <ReactIntlTelInput
    //   preferredCountries={['id']}
    //   onlyCountries={['id', 'sg']}
    //   css={['intl-tel-input', 'form-control']}
    //   style={{width: '100%'}}
    //   onPhoneNumberChange={this._handler}
    //   onPhoneNumberBlur={this._handler}
    //   nationalMode={false}
    //   value={this.state.value}
    //   utilsScript={'libphonenumber.js'}
    //   fieldName={this.props.name}
    // />

    return <div className='intl-tel-input'>
      <div className='flag-container'>
        <div class='iti-flag id' />
      </div>
      <input type='tel' autocomplete='off' className='form-control' name='support_phone' placeholder='0812-345-678' onChange={this._handler} />
    </div>
  }

  _handler = (status, value, countryData, number, id) => {
    this.setState({value: number})
  }
}

IntlTelInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string
}

export {
  RFIntlTelInput
}

export default IntlTelInput



// WEBPACK FOOTER //
// app/javascript/components/fields/IntlTelInput/IntlTelInput.js